import { keyframes } from 'styled-components'

export const pulseAnimation = (lightGray: string, gray: string) => keyframes`
  0% {
    background-color: ${lightGray};
  }
  50% {
    background-color: ${gray};
  }
  100% {
    background-color: ${lightGray};
  }
`
